import { fetchWrapper } from "@/helpers/fetch-wrapper";

const API_URL = process.env.VUE_APP_SERVER_URL;

/**
 * Đăng ký FCM token với server
 * @param {string} token FCM token từ Firebase
 * @returns {Promise} Promise với kết quả từ server
 */
export async function subscribeFCMToServer(token) {
    if (!token) {
        console.error('FCM token không tồn tại');
        return;
    }

    try {
        return await fetchWrapper.post(`${API_URL}/api/subscribe-device-token`, {
            fcm_token: token,
        });
    } catch (error) {
        console.error('Lỗi khi đăng ký FCM token với server:', error);
        throw error;
    }
}

/**
 * Hủy đăng ký FCM token với server
 * @param {string} token FCM token cần hủy
 * @returns {Promise} Promise với kết quả từ server
 */
export async function unsubscribeFCMFromServer(token) {
    if (!token) {
        console.error('FCM token không tồn tại');
        return;
    }

    try {
        return await fetchWrapper.post(`${API_URL}/api/unsubscribe-device-token`, {
            fcm_token: token,
        });
    } catch (error) {
        console.error('Lỗi khi hủy đăng ký FCM token với server:', error);
        throw error;
    }
}
